import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import logoEn from '../../../../img/nhl/MOLSONEXPORT-LNH-EN.png';
import logoFr from '../../../../img/nhl/MOLSONEXPORT-LNH-FR.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function NhlMolsonExport({ className }) {
    const { locale } = useIntl();
    return <img src={locale === 'fr' ? logoFr : logoEn} className={className} alt="" />;
}

NhlMolsonExport.propTypes = propTypes;
NhlMolsonExport.defaultProps = defaultProps;

export default NhlMolsonExport;
